import { render } from "./SchemasSelect.vue?vue&type=template&id=01324709&scoped=true"
import script from "./SchemasSelect.vue?vue&type=script&lang=js"
export * from "./SchemasSelect.vue?vue&type=script&lang=js"

import "./SchemasSelect.vue?vue&type=style&index=0&id=01324709&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01324709"]])

export default __exports__